import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import MainContainer from '@blocks/MainContainer'
import { route } from '@helpers'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'

export default function Empty() {
    useTitle("Group")

    useMainTemplate({ category: "club" })

    return (
        <MainContainer heading="Group">
            <Grid>
                <Grid gap="5px">
                    <h1 className="h3">Create a group or join one</h1>
                    <p style={{ maxWidth: "450px" }}>You can be a part of a group. It facilitates participation in salons for you and your group's members.</p>
                </Grid>
                <Grid gap="15px">
                    <EmphasizedContent>
                        <Grid columns="3">
                            <Grid gap="10px">
                                <h4>Create</h4>
                                <small>You can create a group at any time. The group allows you to monitor members activity from your cabinet, get discounts for your group or receive awards on the group's address.</small>
                                <Button type="tertiary" width="auto" to={route("club:customer:create")}>Create a group</Button>
                            </Grid>
                        </Grid>
                    </EmphasizedContent>
                    <EmphasizedContent>
                        <Grid columns="3">
                            <Grid gap="10px">
                                <h4>Join</h4>
                                <small>You can join a group when a group's head sends you a link to join it. It gives you an easy access to your group's discounts.</small>
                            </Grid>
                        </Grid>
                    </EmphasizedContent>
                </Grid>
            </Grid>
        </MainContainer>
    )
}